module.exports = __webpack_public_path__ + "img/pic7.e6c83142.png";